module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/1-5mill-inactive-75bdba3c599033c06922dfdbacebe392.png";